<!--
[configStart]
{
  "lazyload": true,
  "iview": true,
  "pageInfo": {
    "title": "一起剪创意素材-2000000商用超清视频素材下载",
    "linkIcon": "${WinInitData/page_info/icon}",
    "keywords": "一起剪创意素材、免费视频素材、短视频素材、商用视频素材、正版素材、视频素材下载、视频剪辑素材、正版视频素材库",
    "description": "一起剪创意素材，汇集2000000可商用超清视频素材，满足新媒体、广告、设计等行业视频素材下载需求，提供科技、城市、商务、医疗、建筑、美食、风景、家具、情感、二闺、搞笑、背景、二闺、片头片尾等海量视频素材下载服务",
    "pluginCss": [
      "../public/css/mCustomScrollbar.css"
    ],
    "pluginJs": [
      "../public/js/jquery.min.2.2.0.js",
      "../public/js/zepto.min.1.2.0.js",
      "../public/js/mCustomScrollbar.js"
    ],
    "macroSeo": ["page-layout.html/header", "page-layout.html/footer"]
  }
}
[configEnd]
-->
<template>
  <div class="about-page">
    <Layout :winPageData="winPageData" :footerVisible="false">
      <header-comp
        :searchValue.sync="searchValue"
        @search="handleSearch"
        :visibilityHeight="320"
        headerClass="header-white"
        gradual
      ></header-comp>

      <banner :height="410" url="https://yiqijian.com/assets/images/header-bg.svg" />
      <div class="about-container">
        <article class="agreement-article">
          <h3 class="article-title">授权许可协议</h3>
          <p>以下是您作为被授权人（以下简称"您"）与色值（广州）新媒体科技有限公司（以下简称“色值公司”）之间就您被授权许可下载、使用色值公司提供的视觉版权素材（以下简称“素材”），即“本服务”所达成的双方协议（以下简称“本协议”）。在使用色值公司提供的视觉版权素材之前，请仔细阅读本协议条款。一旦您进行下载等行为，即表明您同意并接受本协议的全部条款的约束，认可所有的权利和义务。</p>
          <p>色值公司有权在必要时修订本协议条款，然后在网站相关页面上提示修改内容。如果您不同意所改动的内容，您有权停止使用。如果您继续使用本协议项下色值公司的服务，则视为接受相关条款的变动。</p>
          <p class="sub-title">一、版权声明</p>
          <p>本网站展示的视觉版权素材著作权归属于色值公司及资源提供方（包括图片资源商、供图作者等）合法享有，受中华人民共和国知识产权法律以及其他相关法律法规保护。</p>
          <p>经相应的授权许可，您对本网站视觉版权素材享有非独家的、非排他性的、不可转让的、不可转许可的、在授权地域内永久使用的权利。</p>
          <p>本协议为单一授权许可，仅允许一位自然人或法人用户下载及使用素材，您必须是素材的最终使用者即最终授权用户，不得进行二次授权或转授权。如果您需要获取超过一个自然人或法人的使用权限，或本协议下的授权不能满足需求，请联系色值公司进行授权升级。</p>
          <p>本协议对视觉版权素材的授权许可使用,不视为所有权或版权已转让给被授权人；除本协议中明确陈述的授权之外，色值公司未授予被授权人对版权素材的其他任何权利。</p>
          <p class="sub-title">二、定义</p>
          <p>本协议中的“被授权人”，指愿意接受本协议、同意按本协议的约定下载并使用视觉版权素材的人（包括自然人、法人、非法人的各类组织等）。</p>
          <p>特别提示：本协议项下被授权人仅限中国大陆地区（不包含香港、澳门、台湾地区）用户主体，非中国大陆地区主体下载本网站版权素材内容无法获得相应授权；如被授权人违反本约定，所造成的后果与色值公司无关。</p>
          <p>本协议的“授权”，指非独家的、非排他性的、不可转让的、不可转许可的、在授权地域内永久使用的权利。</p>
          <p>本协议的“授权地域”，指使用的地域范围为全球。</p>
          <p>本协议中的“视觉版权素材”，简称“素材”，指具有独创性并能以某种有形形式复制的版权素材，包括但不限于摄影照片、漫画、绘画、动态图、矢量、字体、视频以及其他版权素材。</p>
          <p class="sub-title">三、扩展授权</p>
          <p>在扩展授权范围下，您可以将视觉版权素材用于标准许可下所有允许的用途，以及以下其他使用范围，具体包括：</p>
          <p>1. 杂志、书籍等封面、封底印刷；</p>
          <p>2. 将素材或者利用素材创作的衍生作品，用在实物商品、网络商品、赠品等（统称为“商品”）中用于销售或分销，包括但不限于明信片、日历、装饰品、艺术品、服饰、玩具、生活用品、墙纸、产品包装等实物商品，以及软件程序、设计模板、壁纸、主题皮肤、课件等网络商品；</p>
          <p>3. 媒体应用：任何网剧、网络视频、网络直播、电影、电视节目、公共表演等；</p>
          <p>4. 户外广告：如易拉宝、灯箱、橱窗、车身、楼宇、户外广告牌等。</p>
          <p class="sub-title">四、授权限制</p>
          <p>您不得超出授权协议条款所约定和允许的使用范围。</p>
          <p>您不得将本网站素材用于任何商业目的，包括但不限于任何商业活动、任何形式的广告宣传、商标或产品推广、促销等。</p>
          <p>您不得将本网站素材用于任何违反国家法律法规、社会公序良俗、色情淫秽、不道德和或侵犯第三人合法权利的用途。</p>
          <p>您不得将本网站素材用于敏感的场景，对图片中人物造成冒犯或贬低，包括但不限于：暗示心理和生理缺陷、暗示性方面的活动或喜好、犯罪、身体或精神虐待或疾病。</p>
          <p>您不得使用以下的方式描述本网站素材中出现的任何人物，亦不得将本网站素材用于以下用途，否则产生的后果与色值公司无关：</p>
          <p>1. 与淫秽色情作品、成人娱乐场所、陪伴服务、约会服务、美容整容、医疗保健品类等有关；</p>
          <p>2. 参与烟草、酒精产品的广告或促销；</p>
          <p>3. 患有生理或心理疾病或用药治疗生理或心理疾病；</p>
          <p>4. 从事不道德或违法犯罪活动；</p>
          <p>5. 其他可能涉嫌侮辱、诽谤等贬损素材中人物的名誉、伤害人物情感或合法权益的方式。</p>
          <p>您不得使用素材（部分或全部）作为官方商标、其他商业标识、logo或其他原产地标识，或上述各项的部分，或以其他方式对任何产品或服务进行背书或暗示背书。</p>
          <p>您不得转售、转让、再分发、转授权或与第三方共享本网站素材使用权。</p>
          <p>您不得以明示或暗示的方式，虚假声明素材由色值公司或素材版权持有人之外的他人所创作。</p>
          <p class="sub-title">五、被授权人责任</p>
          <p>您应当充分理解本协议中各项条款，保证有权利签订本协议，否则您在本网站的活动将被视违约行为。</p>
          <p>您可以将本网站素材交给第三方，按照本授权协议条款的要求进行打印和制作包含本网站素材的商品，但您必须是最终用户，并且应当采取合理的商业措施防止第三方复制和使用任何素材。</p>
          <p>您理解并同意，对于因将素材用于本协议未明确允许的用途所导致的任何损害赔偿或其他法律责任，您都将向色值公司及色值公司的资源提供方承担责任并赔偿全部损失。</p>
          <p>您理解并同意，在使用本网站素材时由于您的个人行为对第三方造成侵权或引发其他赔偿，色值公司不承担任何责任，因为您的行为对色值公司造成的损失您需要一并进行赔偿。</p>
          <p>您理解并同意，如果您违反与色值公司之间订立的本协议或任何其他协议的条款，而因此产生一切费用和开支，您都将对色值公司进行补偿。</p>
          <p>当您违反了本协议中的条款，本网站有权终止您的账户以及本网站的其他合法权利。</p>
          <p class="sub-title">六、网站有限责任</p>
          <p>本网站保证对基于本协议所许可您使用的素材享有合法的著作权或已获得著作权人的合法授权</p>
          <p>本网站仅对素材本身作出保证，对于被授权人修改素材内容或超出授权范围使用素材而导致的任何后果，本网站不承担任何责任。</p>
          <p class="sub-title">七、用户使用规范</p>
          <p>在使用本网站提供的服务前您需要按照相关提示进行注册，本网站将给予您一个账号及相应的密码，该账号的所有权归色值公司所有，仅您本人可以获得该账号的使用权，不得赠与、借用、租用、转让、出售或以其他方式许可他人使用您的账号。</p>
          <p>您在注册成为本网站用户时，必须提供准确的个人资料，并负有及时更新的义务,同时请您负责妥善保管用户账号和密码,您应当对以其用户账号进行的所有活动和事件承担法律责任，本网站有权随时监控使用状态，当发现您的账号出现多人使用或其他异常使用的情况，本网站将有权随时关闭您的账号。</p>
          <p>八、其他事项</p>
          <p>本协议自双方签订之日起生效，于本网站账号正式关闭之日终止。</p>
          <p>本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。若您和本网站发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交广州市天河区人民法院诉讼解决。</p>
          <p>本协议所有条款的标题仅为阅读方便，本身并无实际含义，不能作为本协议含义解释的依据。</p>
          <p>本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
          <p>本协议最终解释权归色值公司所有。</p>
        </article>
      </div>
      <div class="about-footer">Copyright© 2020 ZAKER.ALL Rights Reserved</div>
    </Layout>
    <!-- <r-login></r-login> -->
  </div>
</template>

<script>
import mixin from '../mixins'
import materialExtends from '../mixins/material-extends'
import '../mock/index.js'
// import rLogin from "../components/r-login"

import Layout from '../components/Layout' // 基础layout
import HeaderComp from '../components/Header'
import Banner from '../components/Banner'

export default {
  components: { Layout, HeaderComp, Banner },
  mixins: [mixin, materialExtends],
  data() {
    return {
      searchValue: ''
    }
  },
  methods: {
    /**
     * @description: 点击搜索
     * @param {string} value
     * @return {void}
     */
    handleSearch(value) {
      this.pushRoute({
        name: 'list',
        params: {
          value
        },
        target: '_self'
      })
    }
  },
  computed: {},
  mounted() {
    this._setSessionToken()
  }
}
</script>

<style lang="less">
@import '../assets/css/index.less';
@import '../assets/css/config.less';

.about-page {
  position: relative;
  // min-height: 100vh;
  // height: 0px;

  .about-container {
    position: relative;
    margin: -362px auto 0;
    max-width: @body-width;
  }

  .article-title {
    margin-bottom: 31px;
    font-size: 30px;
    font-weight: bold;
    color: #3B3B3B;
  }

  .agreement-article {
    padding: 0 (@body-width - 642) / 2px;
    font-size: 16px;
    line-height: 24px;
    color: #3B3B3B;

    .sub-title {
      font-size: 18px;
      font-weight: bold;
    }

    p {
      margin-bottom: 24px;
    }
  }

  .about-footer {
    padding: 32px 0;
    text-align: center;
    color: #666;
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// about.vue?434c19f8